module.exports = __webpack_public_path__ + "static/media/second_white_strip.1a640b1e.svg";